import React from "react";

/**
 * 汎用テキストコンポーネント
 * @param {object} props
 * @param {React.ReactNode} props.children - テキスト内容
 * @param {string} [props.as] - タグ名（h1,h2,p,spanなど）
 * @param {string} [props.className] - 追加クラス
 */
const Text = ({ children, as = "span", className }) => {
  if (React.Children.count(children) === 0) {
    return null;
  }
  const Tag = as;
  return <Tag { ...(className && { className }) }>{children}</Tag>;
};

export default Text; 